import { useQuery } from "@tanstack/react-query";

import { billingStatusQueryOptions } from "./billingStatusQueryOptions";

// Статус Pro. У гостя не запрашивается (`enabled`): без входа покупать нечего.
export const useBillingStatus = (enabled: boolean) =>
  useQuery({ ...billingStatusQueryOptions(), enabled });
